/**
 * @author jaeho.lee104 on 2023. 04. 06..
 */
export class StringConstants {
    static SPACE = "\u00A0";
}